import { Pipe, PipeTransform } from '@angular/core';
import { isNumber, separateThousands } from '@nk/utils-lib';
import { abbrNumber } from '@nk/shared/pipes/abr-number.pipe';

@Pipe({
  name: 'abrNumberOrThousandSep',
  standalone: false,
})
export class AbrNumberOrThousandSepPipe implements PipeTransform {
  /*
    If number is higher than `maxValueBeforeAbbr` we will abbreviate the number.
    Use this to show precision in lower numbers and abbreviation in higher numbers
    digits: Number of digits in smaller number.
    abrDenominator: How manu values after abreviation. i.e "1.23 million" is 2
   */
  public transform(value: number, digits = 2, abrDenominator = 3, maxValueBeforeAbbr = 1000000000): string {
    if (!isNumber(value)) {
      return '-';
    }
    if (value >= maxValueBeforeAbbr) {
      return abbrNumber(value, abrDenominator);
    }
    if (value < maxValueBeforeAbbr) {
      return separateThousands(value, ' ', digits);
    }
  }
}
